// ./recprods.js

export const mockProducts = [
   // --- CLEANSERS (OIL-BASED / PM FIRST CLEANSE) ---
   {
     id: 1,
     name: "Deep Cleansing Oil",
     brand: "DHC",
     category: "Cleanser (Oil)",
     image: "https://imgs.search.brave.com/nqcCK8i5RysT1tva7wFdf-D1D0h9XKZ4qDDH7upYF7Q/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/NjFyWlpnSld0OEwu/anBn",
     price: 29.50,
     originalPrice: 31.00,
     pricePerOz: 4.39,
     rating: 4.6,
     reviewCount: 15234,
     compatibilityScore: 92,
     keyIngredients: ["Olive Oil", "Rosemary Leaf Oil", "Vitamin E"],
     isWishlisted: false,
     sampleAvailable: true,
     skinConcerns: ['clogged-pores', 'dullness'],
     crueltyFree: false,
     fragranceFree: true,
     description: "The original Japanese 1-step oil cleanser. Dissolves makeup, sunscreen, and impurities. Rinses clean with no greasy residue."
   },
   {
     id: 2,
     name: "Clean It Zero 3-in-1 Cleansing Balm",
     brand: "Banila Co",
     category: "Cleanser (Oil)",
     image: "https://imgs.search.brave.com/nauZt8Y5U_b-pZmjMp_7dxYtVi8eiGPuiAtoVl32JgY/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/NDFZZ1I2NWJZUEwu/anBn",
     price: 19.00,
     originalPrice: 19.00,
     pricePerOz: 5.61,
     rating: 4.7,
     reviewCount: 22840,
     compatibilityScore: 94,
     keyIngredients: ["Vitamin E", "Vitamin C", "Acerola Extract"],
     isWishlisted: true,
     sampleAvailable: false,
     skinConcerns: ['clogged-pores', 'dryness'],
     crueltyFree: true,
     fragranceFree: false,
     description: "A lightweight sorbet-like cleansing balm that melts into an oil to remove makeup and impurities. Leaves skin hydrated and soft."
   },
   {
     id: 3,
     name: "Oat Cleansing Balm",
     brand: "The INKEY List",
     category: "Cleanser (Oil)",
     image: "https://imgs.search.brave.com/B8CRGMDvkAzGBCyaJtk-Y_IbJ57ybeBeqv6L-GWp9m8/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/d29ydGhlZWNvc21l/dGljcy5jb20vY2Ru/L3Nob3AvZmlsZXMv/b2F0X2NsZWFuc2lu/Z19iYWxtXzIuanBn/P3Y9MTc1NDM1NjY2/OCZ3aWR0aD0xNTAw",
     price: 12.99,
     originalPrice: 12.99,
     pricePerOz: 2.59,
     rating: 4.4,
     reviewCount: 3450,
     compatibilityScore: 95,
     keyIngredients: ["Oat Kernel Oil", "Colloidal Oatmeal"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['sensitivity', 'redness', 'dryness'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A rich cleansing balm that melts away makeup and impurities. Formulated with oat oil to soothe and reduce redness."
   },
 
   // --- CLEANSERS (WATER-BASED / AM & PM SECOND CLEANSE) ---
   {
     id: 4,
     name: "Hydrating Facial Cleanser",
     brand: "CeraVe",
     category: "Cleanser (Water)",
     image: "https://imgs.search.brave.com/FM9BrbMWqoctMUQjd5ctGn_Hvt7Mx7cVVtc6N0gIfEI/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9pNS53/YWxtYXJ0aW1hZ2Vz/LmNvbS9zZW8vQ2Vy/YVZlLUh5ZHJhdGlu/Zy1GYWNpYWwtQ2xl/YW5zZXItRGFpbHkt/RmFjZS1XYXNoLWZv/ci1Ob3JtYWwtdG8t/RHJ5LVNraW4tOC1m/bC1vel8wYTQzYTA0/MC00NDQ0LTQxYTUt/ODA2NS1mM2M1NTA5/ZWM1M2IuMDUyMTg3/YTg2NGIwOWI3OWU1/Y2FiYTkzODkwM2M4/MmMuanBlZz9vZG5I/ZWlnaHQ9MzIwJm9k/bldpZHRoPTMyMCZv/ZG5CZz1GRkZGRkY",
     price: 16.99,
     originalPrice: 18.99,
     pricePerOz: 1.06,
     rating: 4.8,
     reviewCount: 45820,
     compatibilityScore: 98,
     keyIngredients: ["Ceramides", "Hyaluronic Acid", "Glycerin"],
     isWishlisted: false,
     sampleAvailable: true,
     skinConcerns: ['dryness', 'sensitivity', 'barrier-repair'],
     crueltyFree: false,
     fragranceFree: true,
     description: "A gentle, non-foaming cleansing lotion that cleanses and hydrates without stripping the skin's natural barrier. Perfect for normal to dry skin."
   },
   {
     id: 5,
     name: "Toleriane Purifying Foaming Cleanser",
     brand: "La Roche-Posay",
     category: "Cleanser (Water)",
     image: "https://imgs.search.brave.com/NMgNHfP3vipPGYw7fxF-E6oc9Mx0xzyC66-ae0ybfLw/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9pLmVi/YXlpbWcuY29tL2lt/YWdlcy9nL3d3d0FB/T1N3dzVoZm5Xbi0v/cy1sMjI1LmpwZw",
     price: 17.99,
     originalPrice: 17.99,
     pricePerOz: 1.33,
     rating: 4.7,
     reviewCount: 22109,
     compatibilityScore: 96,
     keyIngredients: ["Niacinamide", "Ceramide-3", "Prebiotic Thermal Water"],
     isWishlisted: true,
     sampleAvailable: false,
     skinConcerns: ['oiliness', 'sensitivity', 'barrier-repair'],
     crueltyFree: false,
     fragranceFree: true,
     description: "A daily foaming cleanser for normal to oily, sensitive skin. Gently cleanses dirt and oil while maintaining the skin's barrier and pH."
   },
   {
     id: 6,
     name: "Superfood Antioxidant Cleanser",
     brand: "Youth to the People",
     category: "Cleanser (Water)",
     image: "https://imgs.search.brave.com/IlnJPYt9RcQOxhKnnqCtZSbf5tUSAoQxO4CjAHu7Fp4/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/MzExcjNONmxKaEwu/anBn",
     price: 39.00,
     originalPrice: 39.00,
     pricePerOz: 4.88,
     rating: 4.6,
     reviewCount: 9876,
     compatibilityScore: 93,
     keyIngredients: ["Kale", "Spinach", "Green Tea"],
     isWishlisted: true,
     sampleAvailable: true,
     skinConcerns: ['clogged-pores', 'dullness', 'oiliness'],
     crueltyFree: true,
     fragranceFree: false,
     description: "A gel cleanser packed with antioxidants to cleanse, remove makeup, and prevent pore buildup without drying. Smells like a green juice."
   },
 
   // --- AM SERUMS (ANTIOXIDANT / VITAMIN C) ---
   {
     id: 7,
     name: "C E Ferulic",
     brand: "SkinCeuticals",
     category: "Antioxidant Serum",
     image: "https://static.thcdn.com/images/large/original/productimg/1600/1600/11289609-1174892770940184.jpg",
     price: 182.00,
     originalPrice: 182.00,
     pricePerOz: 182.00,
     rating: 4.8,
     reviewCount: 9872,
     compatibilityScore: 90,
     keyIngredients: ["15% L-Ascorbic Acid", "1% Vitamin E", "0.5% Ferulic Acid"],
     isWishlisted: true,
     sampleAvailable: false,
     skinConcerns: ['aging', 'dullness', 'hyperpigmentation'],
     crueltyFree: false,
     fragranceFree: true,
     description: "The gold-standard Vitamin C serum. Provides advanced environmental protection, improves signs of aging, and brightens skin."
   },
   {
     id: 8,
     name: "The Glow Maker",
     brand: "Maelove",
     category: "Antioxidant Serum",
     // Maelove is direct-to-consumer only, using a high-quality visual dupe from Amazon
     image: "https://imgs.search.brave.com/OeWCni2_ki2jR7qbycUrgHWUBA3OR3VdVAruUhbfqHo/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9rYXRl/bWluaW1hbGlzdC5j/b20vY2RuL3Nob3Av/cHJvZHVjdHMvNjE0/WmNQSjBQZkxfNzAw/eDcwMC5qcGc_dj0x/NzEwNTQ5MjIx",
     price: 32.95,
     originalPrice: 32.95,
     pricePerOz: 32.95,
     rating: 4.7,
     reviewCount: 10450,
     compatibilityScore: 95,
     keyIngredients: ["15% L-Ascorbic Acid", "Vitamin E", "Ferulic Acid", "Hyaluronic Acid"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['aging', 'dullness', 'hyperpigmentation', 'dryness'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A cult-favorite, affordable alternative to high-end Vitamin C serums. Brightens, hydrates, and protects with a non-sticky finish."
   },
   {
     id: 9,
     name: "C-Firma Fresh Day Serum",
     brand: "Drunk Elephant",
     category: "Antioxidant Serum",
     image: "https://imgs.search.brave.com/c80FOTsdZQgZ5hqa8BcSQ7ItfwJqwG5j9pxgxp7Gwus/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/MzFQdHJnQ1JlYkwu/anBn",
     price: 78.00,
     originalPrice: 78.00,
     pricePerOz: 82.11,
     rating: 4.3,
     reviewCount: 3201,
     compatibilityScore: 89,
     keyIngredients: ["15% L-Ascorbic Acid", "Ferulic Acid", "Pumpkin Ferment Extract"],
     isWishlisted: true,
     sampleAvailable: false,
     skinConcerns: ['aging', 'dullness', 'hyperpigmentation'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A potent Vitamin C serum designed to be mixed by you before its first use to ensure maximum freshness and potency."
   },
 
   // --- HYDRATING SERUMS (AM/PM) ---
   {
     id: 10,
     name: "Hyaluronic Acid 2% + B5",
     brand: "The Ordinary",
     category: "Hydrating Serum",
     image: "https://imgs.search.brave.com/1s40XtFeeYexnLpIUbJ-NkaWbkVWO0byhS57gYcHxn4/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9zaG9w/bG9uZG9uLmluL2Nk/bi9zaG9wL2ZpbGVz/LzFfYmJmMjdlMmIt/MzcyYy00Mzg3LThl/MzUtZjRlNDBhNzY3/MmM5LnBuZz92PTE3/NDk5Mzc3MjYmd2lk/dGg9MTQ0NQ",
     price: 9.90,
     originalPrice: 9.90,
     pricePerOz: 9.90,
     rating: 4.5,
     reviewCount: 30145,
     compatibilityScore: 95,
     keyIngredients: ["Hyaluronic Acid", "Vitamin B5 (Panthenol)"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['dryness', 'dehydration'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A water-based hydration serum that attracts moisture to the skin. Use AM or PM before creams for a multi-depth hydration boost."
   },
   {
     id: 11,
     name: "Minéral 89 Hyaluronic Acid Face Serum",
     brand: "Vichy",
     category: "Hydrating Serum",
     image: "https://imgs.search.brave.com/0zJ4U27aITfMvolYCYDMENBL4vel0Ux5vvE3_dMbClc/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/bG9va2ZhbnRhc3Rp/Yy5jb20vaW1hZ2Vz/P3VybD1odHRwczov/L3N0YXRpYy50aGNk/bi5jb20vcHJvZHVj/dGltZy9vcmlnaW5h/bC8xMTQ5OTI4NC0x/NjA1MjE2Nzk2NDM2/Nzc5LmpwZyZmb3Jt/YXQ9d2VicCZhdXRv/PWF2aWY",
     price: 29.99,
     originalPrice: 34.50,
     pricePerOz: 17.74,
     rating: 4.7,
     reviewCount: 19834,
     compatibilityScore: 97,
     keyIngredients: ["Hyaluronic Acid", "Vichy Volcanic Water"],
     isWishlisted: false,
     sampleAvailable: true,
     skinConcerns: ['dryness', 'dehydration', 'barrier-repair', 'sensitivity'],
     crueltyFree: false,
     fragranceFree: true,
     description: "A minimalist formula with 89% volcanic water and hyaluronic acid. Plumps and strengthens the skin barrier."
   },
 
   // --- MOISTURIZERS (LIGHT / AM / OILY/COMBO) ---
   {
     id: 12,
     name: "Hydro Boost Water Gel",
     brand: "Neutrogena",
     category: "Moisturizer (Light)",
     image: "https://imgs.search.brave.com/9XZJdt1-ImWNRezVNaLgobL0abDRRulnS2GD2Vdo31s/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9pbWFn/ZXMtbmEuc3NsLWlt/YWdlcy1hbWF6b24u/Y29tL2ltYWdlcy9J/LzYxOUdHdU9uTjdM/LmpwZw",
     price: 21.49,
     originalPrice: 26.99,
     pricePerOz: 12.64,
     rating: 4.6,
     reviewCount: 78921,
     compatibilityScore: 97,
     keyIngredients: ["Hyaluronic Acid", "Glycerin"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['dryness', 'dehydration', 'oiliness'],
     crueltyFree: false,
     fragranceFree: false,
     description: "An oil-free, non-comedogenic gel-cream that provides intense hydration. Absorbs quickly like a gel but has the lasting power of a cream."
   },
   {
     id: 13,
     name: "PM Facial Moisturizing Lotion",
     brand: "CeraVe",
     category: "Moisturizer (Light)",
     image: "https://www.cerave.com/-/media/project/loreal/brand-sites/cerave/americas/us/skincare/2025/pm-facial-lotion/700x785/pm-facial-lotion-front-li-badge-700x785-v2.jpg?rev=cbb7009183c440bf88700493a280e336&w=900&hash=077D35A558ADE1076A792E57BD0D958B",
     price: 16.99,
     originalPrice: 16.99,
     pricePerOz: 5.66,
     rating: 4.8,
     reviewCount: 65430,
     compatibilityScore: 99,
     keyIngredients: ["Niacinamide", "Ceramides", "Hyaluronic Acid"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['barrier-repair', 'sensitivity', 'redness', 'acne'],
     crueltyFree: false,
     fragranceFree: true,
     description: "An ultra-lightweight, non-greasy night cream that is also perfect for daytime use. Calms and restores the skin barrier."
   },
 
   // --- MOISTURIZERS (RICH / PM / DRY/NORMAL) ---
   {
     id: 14,
     name: "Ultra Facial Cream",
     brand: "Kiehl's",
     category: "Moisturizer (Rich)",
     image: "https://imgs.search.brave.com/8Ghd_xMxMylqGxec_D4KVBvn9JDAokuV3Y-ns0c1N8U/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9raWVo/bHMuZXNob3BzLmhr/L2ltYWdlLWNhY2hl/L3VwbG9hZHMvc2tp/biUyMGNhcmUvbW9p/c3R1cml6ZXJzL1Vs/dHJhJTIwRmFjaWFs/JTIwQ3JlYW0vMjAy/MzExMDkta2xicmFu/ZC11bHRyYS1mYWNp/YWwtY3JlYW0tMS01/MC5qcGdAMC53ZWJw/P3Y9MDkyMi4wOTIw",
     price: 38.00,
     originalPrice: 38.00,
     pricePerOz: 22.35,
     rating: 4.8,
     reviewCount: 19430,
     compatibilityScore: 95,
     keyIngredients: ["Glacial Glycoprotein", "Squalane"],
     isWishlisted: true,
     sampleAvailable: true,
     skinConcerns: ['dryness', 'dehydration', 'barrier-repair'],
     crueltyFree: false,
     fragranceFree: true,
     description: "A 24-hour hydrating daily moisturizer. With a lightweight texture, it provides lasting moisture for all skin types, even in extreme cold."
   },
   {
     id: 15,
     name: "Lala Retro Whipped Cream",
     brand: "Drunk Elephant",
     category: "Moisturizer (Rich)",
     image: "https://imgs.search.brave.com/1WxNnLff8C_swwTXUMkkIGKVlKwK7oQmXeWMiJ5iy04/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/Y29zbWV0aWZ5LmNv/bS9pbWFnZXMvc3Vw/cGxlbWVudGFyeS9k/cnVuay1lbGVwaGFu/dC1sYWxhLXJldHJv/LXdoaXBwZWQtY3Jl/YW0tMTU3ODM5Mjcw/Ny0xMTExMThfYndq/eHpyZS5qcGc",
     price: 62.00,
     originalPrice: 62.00,
     pricePerOz: 36.68,
     rating: 4.5,
     reviewCount: 7654,
     compatibilityScore: 90,
     keyIngredients: ["6 African Oils", "Ceramides", "Peptides"],
     isWishlisted: true,
     sampleAvailable: true,
     skinConcerns: ['dryness', 'barrier-repair', 'aging'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A rich, restorative cream that provides barrier support and moisture. Comes in an airless-pump jar to keep ingredients stable."
   },
   {
     id: 16,
     name: "Skinfix Barrier+ Triple Lipid-Peptide Cream",
     brand: "Skinfix",
     category: "Moisturizer (Rich)",
     // Using a Sephora/Dermstore equivalent link found on a stable CDN
     image: "https://imgs.search.brave.com/QNLfbv46NaURWJTx---Pft0YqymxN-hvkzBjH5ZdGvs/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9jZG4x/MS5iaWdjb21tZXJj/ZS5jb20vcy1pbGd4/c3k0dDgyL2ltYWdl/cy9zdGVuY2lsLzYw/OHg2MDgvcHJvZHVj/dHMvMjAyNzU1LzQ3/NTkzNC9za2luZml4/NTBtbF9jX180NTM3/MC4xNjc1NDA4MTky/LmpwZz9jPTE", 
     price: 54.00,
     originalPrice: 54.00,
     pricePerOz: 31.95,
     rating: 4.7,
     reviewCount: 4501,
     compatibilityScore: 98,
     keyIngredients: ["Triple Lipid Complex", "Peptides", "Hyaluronic Acid"],
     isWishlisted: true,
     sampleAvailable: false,
     skinConcerns: ['barrier-repair', 'dryness', 'sensitivity', 'aging', 'redness'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A deeply nourishing cream clinically proven to repair the skin barrier in one hour. Ideal for very dry or compromised skin."
   },
 
   // --- SUNSCREEN (AM FINAL STEP) ---
   {
     id: 17,
     name: "UV Clear Broad-Spectrum SPF 46",
     brand: "EltaMD",
     category: "Sunscreen",
     image: "https://imgs.search.brave.com/ZyB8CQ0fJ-4aQsqrNK3_Mh-c2eWl0mlwbm6fCD7iIaM/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/ZGVybXN0b3JlLmNv/bS9pbWFnZXM_dXJs/PWh0dHBzOi8vc3Rh/dGljLnRoY2RuLmNv/bS9wcm9kdWN0aW1n/L29yaWdpbmFsLzEx/MzcwMzAzLTMyMzUy/MDg1MDc0MDU3ODku/anBnJmZvcm1hdD13/ZWJwJmF1dG89YXZp/Zg",
     price: 41.00,
     originalPrice: 43.00,
     pricePerOz: 24.11,
     rating: 4.9,
     reviewCount: 35123,
     compatibilityScore: 99,
     keyIngredients: ["Zinc Oxide", "Niacinamide", "Octinoxate"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['acne', 'sensitivity', 'redness', 'hyperpigmentation'],
     crueltyFree: false,
     fragranceFree: true,
     description: "A dermatologist-recommended hybrid (mineral/chemical) sunscreen. Calms and protects sensitive, acne-prone skin. No white cast."
   },
   {
     id: 18,
     name: "Unseen Sunscreen SPF 40",
     brand: "Supergoop!",
     category: "Sunscreen",
     image: "https://imgs.search.brave.com/80ucxhoX0da70IMiChKxjcpWxIHV590dtsdIWDFpAfs/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9zdXBl/cmdvb3AuY29tL2Nk/bi9zaG9wL2ZpbGVz/L1Vuc2Vlbl9NaW5l/cmFsX0FsdF8xX1Vw/ZGF0ZS5qcGc_dj0x/NzE2OTg3Mzk3Jndp/ZHRoPTExODA",
     price: 38.00,
     originalPrice: 38.00,
     pricePerOz: 25.33,
     rating: 4.7,
     reviewCount: 12056,
     compatibilityScore: 94,
     keyIngredients: ["Avobenzone", "Homosalate", "Octocrylene"],
     isWishlisted: true,
     sampleAvailable: true,
     skinConcerns: ['oiliness', 'texture'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A 100% invisible, weightless, scent-free chemical sunscreen. Acts as a makeup-gripping primer while providing broad-spectrum protection."
   },
   {
     id: 19,
     name: "Relief Sun : Rice + Probiotics (SPF50+)",
     brand: "Beauty of Joseon",
     category: "Sunscreen",
     image: "https://imgs.search.brave.com/4oU8WV6dDfU2tjG3DmXirdokyQhE30A3tZXNzzESWpw/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9wdXJl/c2VvdWwuY28udWsv/Y2RuL3Nob3AvcHJv/ZHVjdHMvQmVhdXR5/LU9mLUpvc2Vvbi1S/ZWxpZWYtU3VuLVJp/Y2UtUHJvYmlvdGlj/cy1wdXJlc2VvdWxf/YTY0NGNiN2UtNzUw/NC00MTk4LWJmNGYt/NTI2Yzg4NzVkOTNi/LnBuZz92PTE2Njkz/ODk3MzUmd2lkdGg9/MTA4MA",
     price: 18.00,
     originalPrice: 23.00,
     pricePerOz: 10.65,
     rating: 4.9,
     reviewCount: 18940,
     compatibilityScore: 98,
     keyIngredients: ["Rice Extract", "Probiotics", "Niacinamide"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['dryness', 'sensitivity', 'dullness'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A viral K-Beauty chemical sunscreen with a lightweight, hydrating, serum-like texture. No white cast and perfect for daily use."
   },
   {
     id: 20,
     name: "Anthelios Mineral Ultra-Light Fluid SPF 50",
     brand: "La Roche-Posay",
     category: "Sunscreen",
     image: "https://imgs.search.brave.com/Nzt1S_qYyD0NVkt_VAt6fAqPcg2_f2BDL8GXv8R_B3o/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/MzFERVM5eFFyWUwu/anBn",
     price: 34.99,
     originalPrice: 34.99,
     pricePerOz: 20.69,
     rating: 4.5,
     reviewCount: 9802,
     compatibilityScore: 91,
     keyIngredients: ["Zinc Oxide", "Titanium Dioxide", "Vitamin E"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['sensitivity'],
     crueltyFree: false,
     fragranceFree: true,
     description: "A 100% mineral sunscreen with a fast-absorbing, lightweight texture. Tinted to offset white cast. Great for sensitive skin."
   },
 
   // --- PM TREATMENTS (RETINOIDS) ---
   {
     id: 21,
     name: "Differin Gel (Adapalene 0.1%)",
     brand: "Differin",
     category: "Retinoid",
     image: "https://imgs.search.brave.com/N7CyJ6sdw7CgWxdRk_NYPb_oK32Dub-X4HsoRzX-HZE/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/YnlyZGllLmNvbS90/aG1iL2lsV1p1LVZ6/NHBaM0FOOUh4QVhq/UElaYnJZcz0vZml0/LWluLzE1MDB4MTEx/Ni9maWx0ZXJzOm5v/X3Vwc2NhbGUoKTpt/YXhfYnl0ZXMoMTUw/MDAwKTpzdHJpcF9p/Y2MoKS9EaWZmZXJp/bkdlbC1iODMzY2M0/YjQ3OTY0NjNjOTI0/MzY4MTBiMDkwY2Nk/Zi5qcGc",
     price: 14.99,
     originalPrice: 18.99,
     pricePerOz: 29.98,
     rating: 4.7,
     reviewCount: 65432,
     compatibilityScore: 90,
     keyIngredients: ["Adapalene 0.1%"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['acne', 'clogged-pores', 'texture'],
     crueltyFree: false,
     fragranceFree: true,
     description: "An FDA-approved, prescription-strength retinoid for clearing acne. Targets pimples, blackheads, and clogged pores."
   },
   {
     id: 22,
     name: "1% Retinol Treatment",
     brand: "Paula's Choice",
     category: "Retinoid",
     image: "https://imgs.search.brave.com/AQWZNtOeifuiR6FcT4hUeDuwiZye-4dMZMjV91ucdTI/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9wYXVs/YXNjaG9pY2UudGgv/Y2RuL3Nob3AvZmls/ZXMvMXBlcmNlbnQt/cmV0aW5vbC10cmVh/dG1lbnQtcGF1bGEt/cy1jaG9pY2UtbWFs/YXlzaWEtMl9kZGNh/YzRkOS0zZmFmLTQ4/MWMtYmYyMC04NjBl/Mzg4ZDE0MTFfMTQw/MHgucG5nP3Y9MTcy/NjA3MjgyOQ",
     price: 64.00,
     originalPrice: 64.00,
     pricePerOz: 64.00,
     rating: 4.6,
     reviewCount: 5690,
     compatibilityScore: 88,
     keyIngredients: ["1% Retinol", "Peptides", "Vitamin C"],
     isWishlisted: true,
     sampleAvailable: true,
     skinConcerns: ['aging', 'hyperpigmentation', 'texture'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A high-strength, advanced retinol serum for experienced users. Targets deep wrinkles, fine lines, and sun damage."
   },
   {
     id: 23,
     name: "Granactive Retinoid 2% Emulsion",
     brand: "The Ordinary",
     category: "Retinoid",
     image: "https://imgs.search.brave.com/mDWKo7FCHGfPce7dlc-4iPPo-OPmH8QiqRCp5iyvyzU/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/ZmFybWVycy5jby5u/ei9JTlRFUlNIT1Av/c3RhdGljL1dGUy9G/YXJtZXJzLVNob3At/U2l0ZS8tL0Zhcm1l/cnMtU2hvcC9lbl9O/Wi9wcm9kdWN0LzY0/LzQzLzMzNS82NDQz/MzM1XzAwX1czNTBf/SDQ1Ni5qcGc_bGFz/dG1vZGlmaWVkPTIw/MjEwMzI4MDE1NTAx/NA",
     price: 12.20,
     originalPrice: 12.20,
     pricePerOz: 12.20,
     rating: 4.5,
     reviewCount: 8901,
     compatibilityScore: 94,
     keyIngredients: ["Granactive Retinoid", "Retinol"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['aging', 'sensitivity', 'texture'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A gentle, non-irritating, next-generation retinoid formula. Ideal for beginners worried about the side effects of traditional retinol."
   },
 
   // --- PM TREATMENTS (BRIGHTENING / HYPERPIGMENTATION) ---
   {
     id: 24,
     name: "Faded Serum for Dark Spots & Discoloration",
     brand: "Topicals",
     category: "Brightening Serum",
     image: "https://imgs.search.brave.com/D97grXLM9bM_aBvhvq8AMxlalftgHL80AvhjHjUTd-w/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9rb3Nt/ZXRpc3RhLmluL3dw/LWNvbnRlbnQvdXBs/b2Fkcy8yMDIzLzEy/L1RvcGljYWxzLU1p/bmktRmFkZWQtU2Vy/dW0tZm9yLURhcmst/U3BvdHMtRGlzY29s/b3JhdGlvbi1QUk9E/VUNULmpwZw",
     price: 38.00,
     originalPrice: 38.00,
     pricePerOz: 22.35,
     rating: 4.3,
     reviewCount: 4102,
     compatibilityScore: 88,
     keyIngredients: ["Tranexamic Acid", "Niacinamide", "Azelaic Acid"],
     isWishlisted: true,
     sampleAvailable: false,
     skinConcerns: ['hyperpigmentation', 'acne-scars', 'dullness'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A powerful gel-serum that targets stubborn hyperpigmentation, dark spots, and post-acne marks. (Note: Has a distinct smell)."
   },
   {
     id: 25,
     name: "Niacinamide 10% + Zinc 1%",
     brand: "The Ordinary",
     category: "Brightening Serum",
     image: "https://imgs.search.brave.com/cpqgpwJSysBb6jgRL1w5pquECw7JR2X1JXjgN9if0wg/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/MjF1SFZway1jbEwu/anBn",
     price: 6.00,
     originalPrice: 6.00,
     pricePerOz: 6.00,
     rating: 4.6,
     reviewCount: 45012,
     compatibilityScore: 92,
     keyIngredients: ["Niacinamide", "Zinc PCA"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['oiliness', 'clogged-pores', 'acne', 'texture'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A universal serum for blemish-prone skin. Reduces the appearance of blemishes, congestion, and visible pores."
   },
 
   // --- PM TREATMENTS (CALMING / BARRIER REPAIR) ---
   {
     id: 26,
     name: "Great Barrier Relief",
     brand: "Krave Beauty",
     category: "Calming Serum",
     image: "https://imgs.search.brave.com/giG_ktRxTNJzQWj-BNFAjr4CoqNmHzcBmdP39tlNjfQ/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/MzF4eGtPSnVuTEwu/anBn",
     price: 28.00,
     originalPrice: 28.00,
     pricePerOz: 18.67,
     rating: 4.8,
     reviewCount: 5678,
     compatibilityScore: 99,
     keyIngredients: ["Tamanu Oil", "Niacinamide", "Ceramides"],
     isWishlisted: true,
     sampleAvailable: false,
     skinConcerns: ['barrier-repair', 'sensitivity', 'redness', 'dryness', 'acne-scars'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A creamy, skin-soothing serum designed to repair a damaged skin barrier. Instantly calms redness, irritation, and sensitivity."
   },
   {
     id: 27,
     name: "Cicapair Tiger Grass Serum",
     brand: "Dr. Jart+",
     category: "Calming Serum",
     image: "https://imgs.search.brave.com/npXHk7ULWVEFn0l61niIGWPjBenIP-mE8Tiyac3GLVo/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/aG9va3Nrb3JlYS5j/b20vY2RuL3Nob3Av/cHJvZHVjdHMvc2tp/bmNhcmUtZHItamFy/dC1jaWNhcGFpci10/aWdlcmdyYXNzLXJl/cGFpci1zZXJ1bS0z/MG1sLTEuanBlZz92/PTE2MDc5ODgxNDUm/d2lkdGg9NDA1",
     price: 55.00,
     originalPrice: 55.00,
     pricePerOz: 55.00,
     rating: 4.5,
     reviewCount: 3019,
     compatibilityScore: 94,
     keyIngredients: ["Centella Asiatica (Cica)", "Niacinamide", "Peptides"],
     isWishlisted: true,
     sampleAvailable: true,
     skinConcerns: ['sensitivity', 'redness', 'barrier-repair'],
     crueltyFree: false,
     fragranceFree: false,
     description: "A highly concentrated serum that calms visible redness and irritation. Strengthens the skin's defense against sensitivity."
   },
 
   // --- WEEKLY TREATMENTS (EXFOLIANTS) ---
   {
     id: 28,
     name: "Skin Perfecting 2% BHA Liquid Exfoliant",
     brand: "Paula's Choice",
     category: "Exfoliant (BHA)",
     image: "https://imgs.search.brave.com/TIXqaJl5ZqSSKuP3TMF4iaeqpPbWlCkfdO7shbKgaU8/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tZWRy/b2NrcGhhcm1hY3ku/Y29tL3dwLWNvbnRl/bnQvdXBsb2Fkcy8y/MDIyLzAyLzcxdmJi/MEFRSUpMLl9TTDE1/MDBfLmpwZw",
     price: 35.00,
     originalPrice: 35.00,
     pricePerOz: 8.75,
     rating: 4.7,
     reviewCount: 55432,
     compatibilityScore: 92,
     keyIngredients: ["Salicylic Acid (BHA)", "Green Tea Extract"],
     isWishlisted: false,
     sampleAvailable: true,
     skinConcerns: ['clogged-pores', 'acne', 'oiliness', 'texture'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A cult-favorite, gentle leave-on exfoliant. Unclogs pores, smooths texture, and evens skin tone. Ideal for oily and acne-prone skin."
   },
   {
     id: 29,
     name: "Glycolic Acid 7% Toning Solution",
     brand: "The Ordinary",
     category: "Exfoliant (AHA)",
     image: "https://imgs.search.brave.com/sjh5AXB466RhA8G0paw8ecSd5h8focN-jfOz7lmrIgo/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9pNS53/YWxtYXJ0aW1hZ2Vz/LmNvbS9hc3IvY2Yz/OTIyYTAtNTcyZi00/MTZhLThiMDAtZWFi/YTA4NzFmZWFkLmYz/YTM0ZGJmMWYwNjgx/ODQyOWRjYTllM2Jj/MDgyNjMwLmpwZWc_/b2RuSGVpZ2h0PTQ1/MCZvZG5XaWR0aD00/NTAmb2RuQmc9ZmZm/ZmZm",
     price: 13.50,
     originalPrice: 13.50,
     pricePerOz: 1.69,
     rating: 4.6,
     reviewCount: 15201,
     compatibilityScore: 87,
     keyIngredients: ["Glycolic Acid", "Tasmanian Pepperberry", "Ginseng"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['dullness', 'texture', 'aging', 'hyperpigmentation'],
     crueltyFree: true,
     fragranceFree: true,
     description: "An exfoliating toner to target dullness, texture, and signs of aging. Use 2-3 times per week in the PM."
   },
   {
     id: 30,
     name: "Good Genes Lactic Acid Treatment",
     brand: "Sunday Riley",
     category: "Exfoliant (AHA)",
     image: "https://imgs.search.brave.com/zuS8Zzj9V21CWkGuzn_jjmDLGd-76TfBGPNPFSntOZE/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9jZG4u/bWFsbC5hZGVwdG1p/bmQuYWkvaHR0cHMl/M0ElMkYlMkZzbGlt/YWdlcy5tYWN5c2Fz/c2V0cy5jb20lMkZp/cyUyRmltYWdlJTJG/TUNZJTJGcHJvZHVj/dHMlMkY2JTJGb3B0/aW1pemVkJTJGMTc0/MTc3MjZfZnB4LnRp/Zl9tZWRpdW0ud2Vi/cA",
     price: 85.00,
     originalPrice: 85.00,
     pricePerOz: 85.00,
     rating: 4.6,
     reviewCount: 8876,
     compatibilityScore: 90,
     keyIngredients: ["Lactic Acid", "Licorice Root", "Prickly Pear Extract"],
     isWishlisted: true,
     sampleAvailable: true,
     skinConcerns: ['dullness', 'texture', 'aging', 'hyperpigmentation'],
     crueltyFree: true,
     fragranceFree: false,
     description: "A high-potency lactic acid serum that exfoliates and brightens. Instantly plumps the look of fine lines and wrinkles."
   },
   {
     id: 31,
     name: "AHA 30% + BHA 2% Peeling Solution",
     brand: "The Ordinary",
     category: "Exfoliant (AHA/BHA)",
     image: "https://imgs.search.brave.com/AMbqMghP0A_6wlwMFcw1ufoPqi_d3G_NO6LEFLatBOo/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly94Y2Ru/Lm5leHQuY28udWsv/Y29tbW9uL2l0ZW1z/L2RlZmF1bHQvZGVm/YXVsdC9pdGVtaW1h/Z2VzLzNfNFJhdGlv/L3Byb2R1Y3QvbGdl/L0FGNDg4NHMyLmpw/Zz9pbT1SZXNpemUs/d2lkdGg9NzUw",
     price: 9.50,
     originalPrice: 9.50,
     pricePerOz: 9.50,
     rating: 4.7,
     reviewCount: 25760,
     compatibilityScore: 80,
     keyIngredients: ["Glycolic Acid", "Lactic Acid", "Salicylic Acid"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['dullness', 'texture', 'acne', 'hyperpigmentation', 'clogged-pores'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A 10-minute exfoliating facial. Use once a week for intense exfoliation to combat blemishes and boost radiance. Not for sensitive skin."
   },
 
   // --- WEEKLY TREATMENTS (MASKS) ---
   {
     id: 32,
     name: "Water Sleeping Mask",
     brand: "LANEIGE",
     category: "Hydrating Mask",
     image: "https://imgs.search.brave.com/-HGkVNJdRhCdcqnL-cBGyA76pYZ--mJpgrHIZLf9c-U/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/MzFoZW9XdXdhaUwu/anBn",
     price: 32.00,
     originalPrice: 32.00,
     pricePerOz: 13.55,
     rating: 4.7,
     reviewCount: 9945,
     compatibilityScore: 95,
     keyIngredients: ["Probiotic-derived Complex", "Squalane", "Glycerin"],
     isWishlisted: true,
     sampleAvailable: true,
     skinConcerns: ['dryness', 'dehydration', 'dullness'],
     crueltyFree: false,
     fragranceFree: false,
     description: "An overnight gel mask that quickly absorbs to hydrate and soothe skin. Wake up to a bright, plump, and refreshed complexion."
   },
   {
     id: 33,
     name: "Rare Earth Deep Pore Cleansing Mask",
     brand: "Kiehl's",
     category: "Clay Mask",
     image: "https://imgs.search.brave.com/0cDNa6XUptsd6yt3YmzHLKRn7qlVlClr7YsqBg4Oz0M/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9pLmVi/YXlpbWcuY29tL2lt/YWdlcy9nL1A4UUFB/T1N3bjNkbEVpemEv/cy1sNTAwLmpwZw",
     price: 47.00,
     originalPrice: 47.00,
     pricePerOz: 10.68,
     rating: 4.6,
     reviewCount: 7890,
     compatibilityScore: 91,
     keyIngredients: ["Amazonian White Clay", "Bentonite Clay", "Aloe Vera"],
     isWishlisted: false,
     sampleAvailable: true,
     skinConcerns: ['clogged-pores', 'oiliness'],
     crueltyFree: false,
     fragranceFree: true,
     description: "A purifying clay mask that helps draw out impurities, reduce excess oil, and minimize the appearance of pores."
   },
   {
     id: 34,
     name: "Jet Lag Mask",
     brand: "Summer Fridays",
     category: "Hydrating Mask",
     image: "https://imgs.search.brave.com/9RdtTyaoFsEwv6Ak1vh7Sua8qGYBRUQw_nx94l47ovg/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/Y3VsdGJlYXV0eS5j/b20vaW1hZ2VzP3Vy/bD1odHRwczovL3N0/YXRpYy50aGNkbi5j/b20vcHJvZHVjdGlt/Zy9vcmlnaW5hbC8x/MzMyMjI3OS02NjY1/MTU1MDU3MDIyMzk3/LmpwZyZmb3JtYXQ9/d2VicCZhdXRvPWF2/aWYmd2lkdGg9NDAw/JmhlaWdodD00MDAm/Zml0PWNvdmVy",
     price: 49.00,
     originalPrice: 49.00,
     pricePerOz: 21.68,
     rating: 4.5,
     reviewCount: 4321,
     compatibilityScore: 93,
     keyIngredients: ["Niacinamide", "Glycerin", "Hyaluronic Acid"],
     isWishlisted: true,
     sampleAvailable: false,
     skinConcerns: ['dryness', 'dehydration', 'dullness', 'sensitivity'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A multi-tasking, creamy mask that can be used as a 10-minute facial, overnight mask, or hydrating primer for stressed skin."
   },
 
   // --- SPECIALTY (EYE CREAMS & SPOT TREATMENTS) ---
   {
     id: 35,
     name: "Banana Bright+ Eye Crème",
     brand: "OLEHENRIKSEN",
     category: "Eye Cream",
     image: "https://imgs.search.brave.com/9pHv-XTbDd2K7xzQSXfQC3Dp4ycG_d8BElFR7y8ODVI/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9mYXNo/aW9uaXN0YS5jb20v/LmltYWdlL2NfbGlt/aXQsY3Nfc3JnYixm/bF9wcm9ncmVzc2l2/ZSxxX2F1dG86Z29v/ZCx3XzcwMC9NVFUw/T1RZM01UTTJPVGcz/TlRJeU56VXovem9v/bV83ZDM2YTM5ZDhi/OWY3ZGM1MTFkM2Ew/NGQzZDk3ZmU5NTRm/MTg4MzY4XzE1MTA4/MjIzMThfMzE4MTFf/b2xlaGVucmlrc2Vu/X3dlYi5qcGc",
     price: 42.00,
     originalPrice: 42.00,
     pricePerOz: 84.00,
     rating: 4.2,
     reviewCount: 6543,
     compatibilityScore: 89,
     keyIngredients: ["Vitamin C", "Collagen", "Banana Powder-Inspired Pigments"],
     isWishlisted: true,
     sampleAvailable: true,
     skinConcerns: ['dark-circles', 'aging', 'dullness'],
     crueltyFree: true,
     fragranceFree: false,
     description: "A potent Vitamin C eye cream that instantly brightens, reduces the look of dark circles, and preps the under-eye for concealer."
   },
   {
     id: 36,
     name: "Retinol Eye Cream",
     brand: "The INKEY List",
     category: "Eye Cream",
     image: "https://imgs.search.brave.com/0jQ2O5kBSS9RsQP80V-x6FshnNdeEt6E5xNs26zfoBI/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/bWVkb2dldC5jb20v/Y2RuL3Nob3AvcHJv/ZHVjdHMvZG93bmxv/YWRfMV9lYTE3YTNi/Yi00ZWE1LTQ1MjUt/Yjk1ZS04YmVmZWFl/ZGUwNDkucG5nP3Y9/MTYyNjk4NjA3OSZ3/aWR0aD0xMDMw",
     price: 12.99,
     originalPrice: 12.99,
     pricePerOz: 25.98,
     rating: 4.3,
     reviewCount: 2109,
     compatibilityScore: 91,
     keyIngredients: ["Retinol", "Squalane"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['aging'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A gentle, slow-release retinol eye cream to target fine lines and wrinkles in the delicate eye area. Ideal for nighttime use."
   },
   {
     id: 37,
     name: "Mighty Patch Original",
     brand: "Hero. Cosmetics",
     category: "Spot Treatment",
     image: "https://imgs.search.brave.com/940954qFPzuEWAzNDuZZ5mY-VfUC2gB8TUtmb5ZwwEc/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9jZG4t/bWVkaWEuaGt0dm1h/bGwuY29tL2hrdHYt/bW1zL0hLVFYvbW1z/L3VwbG9hZFByb2R1/Y3RJbWFnZS8zZjVh/LzhkYmYvMjNkZi9Z/cldaTHBNY2V2MjAy/NDA3MjMxMTI1NDhf/MTIwMC5qcGc",
     price: 12.99,
     originalPrice: 12.99,
     pricePerOz: 0.36,
     rating: 4.7,
     reviewCount: 89765,
     compatibilityScore: 99,
     keyIngredients: ["Hydrocolloid"],
     isWishlisted: false,
     sampleAvailable: false,
     skinConcerns: ['acne'],
     crueltyFree: true,
     fragranceFree: true,
     description: "A hydrocolloid pimple patch that visibly flattens and pulls gunk out of pimples overnight. Protects from picking."
   }
 ];